// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["css/editor-styles","css/site"], () => (__webpack_require__("./src/js/site.js")))
__webpack_require__.O(undefined, ["css/editor-styles","css/site"], () => (__webpack_require__("./src/css/site.scss")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["css/editor-styles","css/site"], () => (__webpack_require__("./src/css/editor-styles.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
